export default "__VITE_ASSET__CpRtz4iK__"